// skipcq: JS-W1028, JS-0128
import React from 'react';
import {
  Container,
  Typography,
  Box,
  CircularProgress,
  Grid,
} from '@mui/material';
import DashboardLayout from '../../components/layout/DashboardLayout';
import CheckinCard from '../../components/checkins/CheckinCard';
import useCheckinsList from '../../hooks/useCheckinsList';

/**
 * Checkins page component displaying the latest 20 checkins
 */
function Checkins() {
  const pageTitle = 'Logged activity';
  const { checkins, loading, error } = useCheckinsList();

  return (
    <DashboardLayout title={pageTitle}>
      <Container fixed>
        {loading ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '50vh',
            }}
          >
            <CircularProgress />
          </Box>
        ) : error ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '50vh',
            }}
          >
            <Typography variant="h6" color="error">
              Error loading logged activity: {error}
            </Typography>
          </Box>
        ) : (
          <Grid
            container
            spacing={0}
            direction="column"
            style={{ minHeight: '100vh', paddingTop: '20px' }}
            sx={{
              alignItems: 'center',
            }}
          >
            {checkins.length === 0 ? (
              <Typography variant="h6" color="text.secondary">
                No logged activity found
              </Typography>
            ) : (
              checkins.map((checkin) => (
                <CheckinCard key={checkin.id} checkin={checkin} />
              ))
            )}
          </Grid>
        )}
      </Container>
    </DashboardLayout>
  );
}

export default Checkins;
